import { gql } from '@apollo/client';
import { UPLOAD_FIELDS } from '../fragments';

export const GET_TOPICS = gql`
  query getTopics($subjectId: String!) {
    topics(subjectId: $subjectId) {
      id
      topicNo
      title
      status
      createdAt
      updatedAt
    }
  }
`;

/** Topics are a subcollection of their subject, so both ids are required. */
export const GET_TOPIC = gql`
  query getTopic($subjectId: String!, $id: String!) {
    topic(subjectId: $subjectId, id: $id) {
      id
      title
      topicNo
      subjectId
      video
      status
      content
      createdAt
      uploads {
        ...UploadFields
      }
    }
  }
  ${UPLOAD_FIELDS}
`;
